// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 850px) {

    .scl--wpchs-cont-stl-bo .scl--web-component-hero-title{
        font-size: 90px;
        line-height: 100%;
    }

    .scl--wpchs-cont-stl-bo .scl--web-component-round-button{
        height: 60px;
        border-radius: 30px;
        width: 300px;
    }

    .scl--wpchs-cont-stl-bo .scl--web-component-round-button .scl--web-component-round-button-text{
        font-size: 24px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item{
        flex-direction: column;
        gap: 30px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-step-number{
        font-size: 18px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content{
        width: 100%; 
        gap: 25px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button{
        width: 392px;
        height: 60px;
        border-radius: 30px;
        padding: 0px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button span{
        font-size: 28px;
        line-height: normal;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button svg{
        width: 25px;
        height: 25px;
        margin-top: 5px;
    }

    .scl--wpchs-cont-stl-bo{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--wpcjus-section-job-seek{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
        flex-direction: column;
    }

    .scl--web-page-career-our-talent-content{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }

    .scl--web-page-career-join-us-title-side{
        width: 100%;
    }

    .scl--web-page-career-view-all-button{
        margin-top: 30px;
        width: 266px;
        height: 49px;
        border-radius: 40px;
    }

    .scl--web-page-career-view-all-button .scl--web-component-round-button-icon svg{
        width: 20px;
        height: 20px;
        margin-top: 3px;
    }

    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-component-round-button-text{
        font-size: 24px;
        line-height: normal;
    }

    .scl--web-page-career-join-us-job-list-side{
        padding-left: 0px;
        width: 100%;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container{
        margin-top: 70px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container h2{
        text-align: start;
        font-size: 70px;
        line-height: 70px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{
        font-size: 28px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-description-container{
        margin-top: 15px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container{
        gap: 50px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container .scl--web-component-talent-title{
        font-size: 40px;
        width: 100%;
    }

    .scl--web-component-talent-description{
        width: 75%;
        font-size: 28px;
        line-height: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/career/css/careerSt.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;QACjD,sBAAsB;IAC1B;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,UAAU;QACV,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["@media (max-width: 850px) {\n\n    .scl--wpchs-cont-stl-bo .scl--web-component-hero-title{\n        font-size: 90px;\n        line-height: 100%;\n    }\n\n    .scl--wpchs-cont-stl-bo .scl--web-component-round-button{\n        height: 60px;\n        border-radius: 30px;\n        width: 300px;\n    }\n\n    .scl--wpchs-cont-stl-bo .scl--web-component-round-button .scl--web-component-round-button-text{\n        font-size: 24px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item{\n        flex-direction: column;\n        gap: 30px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-step-number{\n        font-size: 18px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content{\n        width: 100%; \n        gap: 25px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button{\n        width: 392px;\n        height: 60px;\n        border-radius: 30px;\n        padding: 0px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button span{\n        font-size: 28px;\n        line-height: normal;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button svg{\n        width: 25px;\n        height: 25px;\n        margin-top: 5px;\n    }\n\n    .scl--wpchs-cont-stl-bo{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--wpcjus-section-job-seek{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n        flex-direction: column;\n    }\n\n    .scl--web-page-career-our-talent-content{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n\n    .scl--web-page-career-join-us-title-side{\n        width: 100%;\n    }\n\n    .scl--web-page-career-view-all-button{\n        margin-top: 30px;\n        width: 266px;\n        height: 49px;\n        border-radius: 40px;\n    }\n\n    .scl--web-page-career-view-all-button .scl--web-component-round-button-icon svg{\n        width: 20px;\n        height: 20px;\n        margin-top: 3px;\n    }\n\n    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-component-round-button-text{\n        font-size: 24px;\n        line-height: normal;\n    }\n\n    .scl--web-page-career-join-us-job-list-side{\n        padding-left: 0px;\n        width: 100%;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container{\n        margin-top: 70px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container h2{\n        text-align: start;\n        font-size: 70px;\n        line-height: 70px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{\n        font-size: 28px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-description-container{\n        margin-top: 15px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container{\n        gap: 50px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container .scl--web-component-talent-title{\n        font-size: 40px;\n        width: 100%;\n    }\n\n    .scl--web-component-talent-description{\n        width: 75%;\n        font-size: 28px;\n        line-height: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
